var render = function render(){
  var _vm$me, _vm$me$point;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', [_c('span', [_vm._v("보유포인트: " + _vm._s(((_vm$me = _vm.me) === null || _vm$me === void 0 ? void 0 : (_vm$me$point = _vm$me.point) === null || _vm$me$point === void 0 ? void 0 : _vm$me$point.format()) || 0) + "원")])]), _c('div', {
    staticClass: "mt-8"
  }, [_c('v-combobox', {
    staticClass: "d-inline-block mx-2",
    attrs: {
      "items": _vm.paymentAmounts,
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "label": "충전금액"
    },
    on: {
      "input": function ($event) {
        return _vm.rename();
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('v-icon', {
          attrs: {
            "color": "blue",
            "left": ""
          }
        }, [_vm._v("mdi-alpha-p-circle")]), _c('span', [_vm._v(_vm._s(parseInt(item).format()))])];
      }
    }, {
      key: "item",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('v-icon', {
          attrs: {
            "color": "grey",
            "left": ""
          }
        }, [_vm._v("mdi-alpha-p-circle")]), _c('span', [_vm._v(_vm._s(parseInt(item).format()))])];
      }
    }]),
    model: {
      value: _vm.order.paymentAmount,
      callback: function ($$v) {
        _vm.$set(_vm.order, "paymentAmount", $$v);
      },
      expression: "order.paymentAmount"
    }
  }), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.charge();
      }
    }
  }, [_vm._v("충전하기")])], 1), _c('nice-pay', {
    ref: "nicepay",
    on: {
      "complete": function (payload) {
        _vm.complete(payload), _vm.init();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }